import React from 'react'
import styles from "./GetHeader.module.css";
import bg from '../../../../assets/dashboard/head.png'
import logo from '../../../../assets/dashboard/logo.png'
import { BACKEND_URL_PREFIX } from '../../../../utils/const';

const GetHeader = ({ title, pathLogo }) => {
  return (
    <div className={styles.header}>
      <img src={bg} className={styles.bg} />
      <img className={styles.logoIns} src={!!pathLogo ? `${pathLogo}company/gou_logo` : `${BACKEND_URL_PREFIX}/company/gou_logo`} alt='Логотип' />
      <img src={logo} className={styles.logo} />
      <p className={styles.title}>{title}</p>
    </div>
  )
}

export default GetHeader